import type {KpiItem} from '@domain/kpis'
import {Box, Grid, Stack, Typography} from '@mui/material'

import {KpiTrendChart, KpiTrendChartSkeleton} from './KpiTrendChart'

const emptyKpiTrendData = {labels: [], data: []}

type Props = {
  kpiItems: KpiItem[]
  areMonthlyKpiTrendsLoading: boolean
  gridColumns?: number
  gridItemXs: number
}

export const PlantStatusKpisTrends: React.FC<Props> = ({
  kpiItems,
  areMonthlyKpiTrendsLoading,
  gridItemXs,
  gridColumns = 12
}) => {
  return (
    <Grid container columns={gridColumns} spacing={2} sx={{maxWidth: '100%', maxHeight: '100%'}}>
      {kpiItems.map((kpiItem) => (
        <Grid item xs={gridItemXs} key={kpiItem.key}>
          <Stack spacing={2} sx={{mt: 1.5}}>
            <Typography variant="caption" data-test-id={`kpi-trend-label-${kpiItem.key}`}>
              {kpiItem.label}
            </Typography>
            <Box sx={{width: '100%', maxHeight: '100%'}}>
              {areMonthlyKpiTrendsLoading ? (
                <KpiTrendChartSkeleton />
              ) : (
                <KpiTrendChart
                  data={kpiItem.monthlyTrendData ?? emptyKpiTrendData}
                  unit={kpiItem.monthlyTrendDataUnit}
                />
              )}
            </Box>
          </Stack>
        </Grid>
      ))}
    </Grid>
  )
}
